<template>
  <v-tooltip
    :location="location"
    :text="text"
    :disabled="disabled"
    :max-width="maxWidth"
    :offset="offset"
    content-class="bg-surface border elevation-8"
    class="so-tooltip"
    data-testid="tooltip"
  >
    <template #activator="{ props }">
      <span v-bind="props">
        <slot v-bind="props" :props="props"></slot>
      </span>
    </template>
    <template v-if="$slots.custom">
      <slot name="custom"></slot>
    </template>
    <div v-else class="py-3 text-body-2">
      <p v-if="title" class="font-weight-medium mb-1">{{ title }}</p>
      <p v-if="text">{{ text }}</p>
    </div>
  </v-tooltip>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"

  type LocationTypes = "top" | "bottom" | "start" | "end"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      location: {
        type: String as PropType<LocationTypes>,
        default: "top",
      },
      title: {
        type: String,
        default: "",
      },
      text: {
        type: String,
        default: "",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      maxWidth: {
        type: String,
        default: "500",
      },
      offset: {
        type: String,
        default: undefined,
      },
    },
  })
</script>
